import * as angular from 'angular';

function filterFunction($filter: ng.IFilterService) {
    return function (store: any) {
        var values = [
            store.Town,
            store.AddressLine1
        ];
        return values.filter(function(value: any) {
            return !!value;
        }).join(', ');
    };
}
angular.module('app.common')
    .filter('storeAddress', ['$filter', filterFunction]);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer.common/modules/filters/store-address.filter.ts